class ComboBoxUtil {
    static getSelectId(selectedItem){
        if (selectedItem === null) {
            return null
        } else if (typeof selectedItem === 'object') {
            return selectedItem.id //selectedItem會回傳整個對應的JSON項目結構，因此可再往下去取出想要的資料屬性
        } else if (typeof selectedItem === 'string') {
            return null 
        } else {
            return null;
        }
    }
    static getSelectName(selectedItem){
        if (selectedItem === null) {
            return null
        } else if (typeof selectedItem === 'object') {
            return selectedItem.name
        } else if (typeof selectedItem === 'string') {
            return selectedItem
        } else {
            return null;
        }
    }
    static getComboBoxModel(val, items, newItem){
        /*
            item固定的資料格式：
            {
                id
                name
            }
        */
        if ((val === null) || (val === undefined)) return newItem
        var returnVal = newItem
        if (typeof(val) === 'string'){
            newItem.name = val //因為傳入的是字串，所以要先把字串值傳入到v物件的name屬性中，以利比對
            //newItem.DisplayText = val
            var hasNew = true
            returnVal = items.map(v =>{
                if (v.id === newItem.id){
                    hasNew = false
                    v.Text = val
                }
            })
            if (hasNew){
                items.push(newItem)
            }
            returnVal = newItem
        } else {
            
            returnVal = val
        }
        return returnVal
        
        /* 
        if ((val === null) || (val === undefined)) return val
        console.log('getComboBoxModel, val=')
        console.log(val)
        console.log(typeof(val))
        if (typeof(val) === 'string'){
            //var v= {id: -1, name: val, insurance_products:[]}
            v.name = val //因為傳入的是字串，所以要先把字串值傳入到v物件的name屬性中，以利比對
            var hasNew = true;
            for (let i = 0; i < items.length; i++) {
                let item = items[i]
                if (item.id === v.id){
                    items[i].name = val
                    v = items[i]
                    hasNew = false
                    break
                }
            }
            if (hasNew){
                items.push(v)
            }
            console.log('getComboBoxModel, v=')
            console.log(v)
            return v
        } else {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (val.id === item.id){
                    //如果是新資料改姓名，就換掉姓名
                    if (val.id == -1){
                        if (val.name.trim() != '') {
                            item.name = val.name
                            items[i].name = val.name
                        }
                    } else {
                        //有找到匹配id時，不允許換姓名, 要把名字換回來
                        val.name = item.name
                    } 
                    return item
                }
                //如果用ID沒找到的話，用姓名比對一下(以後可能會有同名不同人的情況)
                if (val.name === item.name){
                    //用name有找到匹配的人，所以就要換id
                    val.id = item.id

                    return item
                }
            }
            //都沒有找到的話
            console.log('getComboBoxModel, val.name=')
            console.log(val.name)
            if (val.name.trim() != ''){
                items.push(val)
            }
            return val
        }
        */
    }
}

export default ComboBoxUtil; //預設匯出為靜態類別